"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledModal = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var hooks_1 = require("@nef/hooks");
var Portal_1 = __importDefault(require("../Portal"));
var ModalHeader_1 = require("../ModalHeader");
var ModalBackdrop_1 = __importDefault(require("./components/ModalBackdrop"));
var ModalContent_1 = __importDefault(require("./components/ModalContent"));
var ModalDialog_1 = __importDefault(require("./components/ModalDialog"));
var ModalContext_1 = __importDefault(require("./components/ModalContext"));
var focusableElements = [
    "a[href]",
    "area[href]",
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "object",
    "embed",
    "[tabindex]:not(.modal)",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
];
var innerFunction = react_1.default.forwardRef(function (_a, ref) {
    var backdrop = _a.backdrop, isOpen = _a.isOpen, keyboard = _a.keyboard, toggle = _a.toggle, closeOnOutsideClick = _a.closeOnOutsideClick, onDrag = _a.onDrag, onResize = _a.onResize, props = __rest(_a, ["backdrop", "isOpen", "keyboard", "toggle", "closeOnOutsideClick", "onDrag", "onResize"]);
    return react_1.default.createElement("div", __assign({}, props, { ref: ref }));
});
innerFunction.displayName = "innerFunction";
exports.StyledModal = styled_components_1.default(innerFunction)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  .danger {\n    ", ";\n  }\n"], ["\n  ",
    ";\n\n  ",
    ";\n\n  ",
    ";\n\n  .danger {\n    ", ";\n  }\n"])), function (props) {
    return props.isOpen && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      overflow-x: hidden;\n      overflow-y: auto;\n    "], ["\n      overflow-x: hidden;\n      overflow-y: auto;\n    "])));
}, function (props) {
    return props.$isDraggable && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", " {\n        cursor: pointer;\n      }\n    "], ["\n      ", " {\n        cursor: pointer;\n      }\n    "])), ModalHeader_1.StyledModalHeader);
}, function (props) {
    return props.$rtl && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      direction: rtl;\n    "], ["\n      direction: rtl;\n    "])));
}, style_utils_1.setAutoMargin("right"));
var Modal = react_1.default.forwardRef(function (_a, ref) {
    var autoFocus = _a.autoFocus, children = _a.children, height = _a.height, isOpen = _a.isOpen, keyboard = _a.keyboard, node = _a.node, onDrag = _a.onDrag, onResize = _a.onResize, onEnter = _a.onEnter, rtl = _a.rtl, size = _a.size, toggle = _a.toggle, backdrop = _a.backdrop, closeOnOutsideClick = _a.closeOnOutsideClick, type = _a.type, isDraggable = _a.isDraggable, isResizable = _a.isResizable, width = _a.width, props = __rest(_a, ["autoFocus", "children", "height", "isOpen", "keyboard", "node", "onDrag", "onResize", "onEnter", "rtl", "size", "toggle", "backdrop", "closeOnOutsideClick", "type", "isDraggable", "isResizable", "width"]);
    var themeRtl = react_1.default.useContext(styled_components_1.ThemeContext).rtl;
    var dialogRef = react_1.default.useRef();
    var wrapperRef = react_1.default.useRef();
    var combinedRef = hooks_1.useCombinedRefs(ref, wrapperRef);
    var setFocus = react_1.default.useCallback(function () {
        var _a, _b;
        (_b = (_a = dialogRef === null || dialogRef === void 0 ? void 0 : dialogRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.focus();
    }, [dialogRef === null || dialogRef === void 0 ? void 0 : dialogRef.current]);
    var getFocusableChildren = react_1.default.useCallback(function () {
        var _a;
        return (_a = wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll(focusableElements.join(", "));
    }, [wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current]);
    var getFocusedChild = react_1.default.useCallback(function () {
        var _a;
        var currentFocus;
        var focusableChildren = getFocusableChildren();
        try {
            if (typeof document !== "undefined") {
                currentFocus = document.activeElement;
            }
            else {
                throw new Error("Document is not defined.");
            }
        }
        catch (err) {
            _a = __read(focusableChildren, 1), currentFocus = _a[0];
        }
        return currentFocus;
    }, [getFocusableChildren]);
    var handleEscape = react_1.default.useCallback(function (e) {
        if (isOpen &&
            keyboard &&
            (e.key === "Escape" || e.key === "Esc") &&
            toggle) {
            e.preventDefault();
            e.stopPropagation();
            toggle(e);
        }
    }, [isOpen, keyboard, toggle]);
    var handleTab = react_1.default.useCallback(function (e) {
        if (e.key !== "Tab") {
            return;
        }
        var focusableChildren = getFocusableChildren();
        var totalFocusable = focusableChildren.length;
        if (totalFocusable === 0) {
            return;
        }
        var currentFocus = getFocusedChild();
        var focusedIndex = 0;
        for (var i = 0; i < totalFocusable; i += 1) {
            if (focusableChildren[i] === currentFocus) {
                focusedIndex = i;
                break;
            }
        }
        if (e.shiftKey && focusedIndex === 0) {
            e.preventDefault();
            focusableChildren[totalFocusable - 1].focus();
        }
        else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
            e.preventDefault();
            focusableChildren[0].focus();
        }
    }, [getFocusableChildren, getFocusedChild]);
    react_1.default.useEffect(function () {
        onEnter === null || onEnter === void 0 ? void 0 : onEnter();
        if (isOpen && autoFocus) {
            setFocus();
        }
    }, [onEnter, isOpen, autoFocus]);
    return (react_1.default.createElement(ModalContext_1.default.Provider, { value: { rtl: themeRtl || rtl } },
        react_1.default.createElement(Portal_1.default, { node: node }, isOpen && (react_1.default.createElement(exports.StyledModal, __assign({}, props, { "$rtl": themeRtl || rtl, "$isDraggable": isDraggable, isOpen: isOpen, onKeyUp: handleEscape, onKeyDown: handleTab, toggle: toggle, ref: combinedRef }),
            backdrop && react_1.default.createElement(ModalBackdrop_1.default, null),
            react_1.default.createElement(ModalDialog_1.default, { ref: dialogRef, isOpen: isOpen },
                react_1.default.createElement(ModalContent_1.default, { height: height, isOpen: isOpen, toggle: toggle, size: size, closeOnOutsideClick: closeOnOutsideClick, type: type, isDraggable: isDraggable, isResizable: isResizable, width: width, onDrag: onDrag, onResize: onResize }, children)))))));
});
Modal.displayName = "Modal";
Modal.defaultProps = {
    backdrop: true,
    isOpen: false,
    size: "md",
    closeOnOutsideClick: true
};
exports.default = Modal;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map